// extracted by mini-css-extract-plugin
export default {"heading":"step-menu_heading__SSjWR"};